'use strict';

import angular from 'angular';
import 'ng-file-upload';
import 'angular-sanitize';
import 'ui-select';
import 'angular-bootstrap';
import 'common/treeModule';
import './sectionsServices';
import '../modules/modulesServices';

const sectionsControllers = angular.module('applicationModule.sectionsControllers', [
    'ngSanitize',
    'applicationModule.modulesServices',
    'applicationModule.sectionsServices',
    'commonModule.treeModule',
    'ngFileUpload',
    'ui.bootstrap',
    'ui.select'
]);

// Section Controllers
sectionsControllers.controller('SectionsListController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'Section', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, Section, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.writeAccess = Permissions.hasWriteAccess('section');
    $scope.mainSection = false;

    $scope.application_id = $stateParams.application_id;
    $scope.check = false;
    $scope.search = {};
    $scope.searchSection = null;
    $scope.searchSection = localStorage.getItem('appsoup:sectionSearch');

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Section.getList($scope.application_id, params._params)
                .then(function (response) {
                    if (angular.isDefined(response)) {
                        if (response.success) {
                            let pages = response.pages;
                            params.total(pages.total);
                            params.count(pages.per_page);
                            params.page(pages.current_page);
                            // Set New Data
                            if (angular.isDefinedNotNull($stateParams.searchSection)) {
                                $scope.search.name = $stateParams.searchSection;
                                $scope.searchSections($scope.search);
                            }
                            return pages.data;
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.editSection = function ($event, section) {
        $event.stopImmediatePropagation();
        var modalInstance = $modal.open({
            templateUrl: 'views/application/sections/components/modal/section.tpl.html',
            controller: 'SectionModalController',
            resolve: {
                section: function () {
                    return angular.extend(section, {superadmin: Permissions.hasSuperAdminAccess()});
                }
            }
        });
        modalInstance.result.then(function (data) {
            growl.success('MODULES.APPLICATIONS.SUCCESS.SECTION_EDITED');
            angular.extend(section, data);
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.deleteSection = function ($event, section) {
        $scope.isLoading = true;
        Section.remove(section.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.SUCCESS.SECTION_DELETED');
                    $state.go('appsoup.application.sections', {application_id: $stateParams.application_id}, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.newSection = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/sections/components/modal/section.tpl.html',
            controller: 'SectionModalController',
            resolve: {
                section: function () {
                    return {
                        superadmin: Permissions.hasSuperAdminAccess()
                    };
                }
            }
        });
        modalInstance.result.then(function (data) {
            $state.go('appsoup.application.sections', {application_id: $stateParams.application_id}, {reload: true});
            growl.success('MODULES.APPLICATIONS.SUCCESS.SECTION_CREATED');
        }).catch(() => {});
    };

        $scope.searchSections = function (search) {
            $scope.isFind = true;
            var find = angular.copy(search);
            angular.extend($scope.tableParams._params, find);
            $scope.searchSection = $scope.search;
            $scope.isFind = false;
            localStorage.setItem('appsoup:sectionSearch', $scope.search.name);
        };

        $scope.clearSearch = function () {
            $scope.search = {};
            if (angular.isDefined($scope.tableParams._params.name)) {
                $scope.tableParams._params.name = undefined;
            }
            $stateParams.searchSection = null;
            $scope.searchSection = null;
            localStorage.removeItem('appsoup:sectionSearch');
        };

        $scope.publishSchema = function (appId) {
            Section.publishSchema(appId).then(function (response) {
                var data = response.data;
                if (data.success) {
                    growl.success('GROWL.SUCCESS.PUBLISH_SCHEMA');
                } else if (data.error) {
                    growl.error('GROWL.ERROR.PUBLISH_SCHEMA');
                }
            });
        };
    }]);

sectionsControllers.controller('SectionPageController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'Section', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, Section, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.writeAccess = Permissions.hasWriteAccess('section');
    $scope.mainSection = true;

    $scope.application_id = $stateParams.application_id;
    $scope.section_id = $stateParams.section_id;
    $scope.check = false;
    $scope.search = {};
    $scope.searchSection = null;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Section.get($scope.section_id)
                .then(function (response) {
                    if (angular.isDefined(response)) {
                        if (response.success) {
                            $scope.section = response.data;
                            $scope.section.modules = response.data.modules;
                            // Update Table Params
                            params.total(response.data.modules.length);
                            // Set New Data
                            return response.data.modules;
                        }
                    }
                })
                .then(function () {
                    $scope.isLoading = false;
                });
        },
        counts: []
    });

    $scope.editSection = function ($event, section) {
        $event.stopImmediatePropagation();
        var modalInstance = $modal.open({
            templateUrl: 'views/application/sections/components/modal/section.tpl.html',
            controller: 'SectionModalController',
            resolve: {
                section: function () {
                    return angular.extend(section, {superadmin: Permissions.hasSuperAdminAccess()});
                }
            }
        });
        modalInstance.result.then(function (data) {
            growl.success('MODULES.APPLICATIONS.SUCCESS.SECTION_EDITED');
            angular.extend(section, data);
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.deleteSection = function ($event, section) {
        $scope.isLoading = true;
        Section.remove(section.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.SUCCESS.SECTION_DELETED');
                    $state.go('appsoup.application.sections', {application_id: $stateParams.application_id}, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.newModule = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/sections/components/modal/module.tpl.html',
            controller: 'ModuleModalController',
            resolve: {
                module: function () {
                    return {
                        section_id: $scope.section_id
                    };
                }
            }
        });
        modalInstance.result.then(function (data) {
            growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_CREATED');
            $state.go('appsoup.application.section', {
                application_id: $stateParams.application_id,
                section_id: $stateParams.section_id
            }, {reload: true});
        }).catch(() => {});
    };

    $scope.editModule = function ($event, module) {
        $event.stopImmediatePropagation();
        var modalInstance = $modal.open({
            templateUrl: 'views/application/sections/components/modal/module.tpl.html',
            controller: 'ModuleModalController',
            resolve: {
                module: function () {
                    return module;
                }
            }
        });
        modalInstance.result.then(function (data) {
            growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_EDITED');
            angular.extend(module, data);
        }).catch(() => {});
    };

    $scope.deleteModule = function ($event, module) {
        $scope.isLoading = true;
        Section.remove(module.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_DELETED');
                    $state.go('appsoup.application.section', {
                        application_id: $stateParams.application_id,
                        section_id: $stateParams.section_id
                    }, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.searchSections = function (search) {
        if (angular.isDefinedNotEmpty($scope.section_id)) {
            $state.go('appsoup.application.section', {
                application_id: $stateParams.application_id,
                section_id: $scope.section_id
            }, {reload: true});
        }
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        $state.go('appsoup.application.sections', {application_id: $stateParams.application_id}, {reload: true});
    };
}]);

sectionsControllers.controller('SectionModalController', ['$scope', '$rootScope', '$state', '$stateParams', '$modalInstance', 'growl', 'section', 'Section', 'Upload', function ($scope, $rootScope, $state, $stateParams, $modalInstance, growl, section, Section, Upload) {
    $scope.section = section;
    $scope.editMode = angular.isDefined(section.id);
    $scope.application_id = $stateParams.application_id;
    $scope.isLoading = true;
    $scope.fileUploaded = false;
    $scope.fileError = false;

    Section.getSectionTags($scope.application_id)
        .then(function (response) {
            if (angular.isDefined(response)) {
                if (response.success) {
                    $scope.tags = response.data.tags;
                }
            }
        })
        .then(function () {
            $scope.isLoading = false;
        });

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.fileUploaded = false;
        $scope.section.image = "";
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.ok = function () {
        $scope.isLoading = true;
        var section = angular.copy($scope.section);
        section.application_id = $scope.application_id;
        Section.save(section, $scope.editMode, $scope.upload)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.fileError = false;
                    $modalInstance.close(data.data);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.ERROR.APP_CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };
}]);

sectionsControllers.controller('ModuleController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'Section', 'Module', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, Section, Module, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.writeAccess = Permissions.hasWriteAccess('section');
    $scope.mainSection = true;

    $scope.application_id = $stateParams.application_id;
    $scope.section_id = $stateParams.section_id;
    $scope.order_id = $stateParams.order_id;
    $scope.check = false;
    $scope.search = {};
    $scope.searchSection = null;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            if (angular.isDefinedNotEmpty($scope.order_id)) {
                Module.get($scope.order_id)
                    .then(function (result) {
                let response = result.data;
                        if (angular.isDefined(response)) {
                            if (response.success) {
                                $scope.module = response.data;
                                $scope.module.elements = response.data.elements;
                                // Update Table Params
                                params.total(response.data.elements.length);
                                // Set New Data
                                return response.data.elements;
                            }
                        }
                    })
                    .then(function () {
                        $scope.isLoading = false;
                    });
            }
        },
        counts: []
    });

    $scope.editModule = function ($event, module) {
        $event.stopImmediatePropagation();
        var modalInstance = $modal.open({
            templateUrl: 'views/application/sections/components/modal/module.tpl.html',
            controller: 'ModuleModalController',
            resolve: {
                module: function () {
                    return module;
                }
            }
        });
        modalInstance.result.then(function (data) {
            growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_EDITED');
            angular.extend(module, data);
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.deleteModule = function ($event, module) {
        $scope.isLoading = true;
        Module.remove(module.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_DELETED');
                    $state.go('appsoup.application.section', {
                        application_id: $stateParams.application_id,
                        section_id: $stateParams.section_id
                    }, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.newModuleElement = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/sections/components/modal/module-element.tpl.html',
            controller: 'ModuleElementModalController',
            resolve: {
                module: function () {
                    return $scope.module;
                },
                module_element: function () {
                    return {
                        module_id: $scope.order_id
                    };
                }
            }
        });
        modalInstance.result.then(function (data) {
            growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_ELEMENT_CREATED');
            $state.go('appsoup.application.sectionModule', {
                application_id: $stateParams.application_id,
                section_id: $stateParams.section_id,
                order_id: $stateParams.order_id
            }, {reload: true});
        }).catch(() => {});
    };

    $scope.editModuleElement = function ($event, module_element) {
        $event.stopImmediatePropagation();
        var modalInstance = $modal.open({
            templateUrl: 'views/application/sections/components/modal/module-element.tpl.html',
            controller: 'ModuleElementModalController',
            resolve: {
                module: function () {
                    return $scope.module;
                },
                module_element: function () {
                    return module_element;
                }
            }
        });
        modalInstance.result.then(function (data) {
            growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_ELEMENT_EDITED');
            angular.extend(module_element, data);
        }).catch(() => {});
    };

    $scope.deleteModuleElement = function ($event, module_element) {
        $scope.isLoading = true;
        Module.removeElement(module_element.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_ELEMENT_DELETED');
                    $state.go('appsoup.application.sectionModule', {
                        application_id: $stateParams.application_id,
                        section_id: $stateParams.section_id,
                        order_id: $stateParams.order_id
                    }, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.searchSections = function (search) {
        $state.go('appsoup.application.section', {
            application_id: $stateParams.application_id,
            section_id: $scope.section_id
        }, {reload: true});
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        $state.go('appsoup.application.sections', {application_id: $stateParams.application_id}, {reload: true});
    };
}]);

sectionsControllers.controller('ModuleModalController', ['$scope', '$rootScope', '$state', '$stateParams', '$modalInstance', 'growl', 'module', 'Module', 'Upload', function ($scope, $rootScope, $state, $stateParams, $modalInstance, growl, module, Module, Upload) {
    $scope.module = module;
    $scope.editMode = angular.isDefined(module.id);
    $scope.application_id = $stateParams.application_id;
    $scope.section_id = $stateParams.section_id;
    $scope.isLoading = true;
    $scope.fileUploaded = false;
    $scope.fileError = false;
    $scope.barcodeUploaded = false;
    $scope.barcodeError = false;
    $scope.logoUploaded = false;
    $scope.logoError = false;
    $scope.moreUploaded = false;
    $scope.moreError = false;

    Module.getModuleTags($scope.application_id)
        .then(function (result) {
                let response = result.data;
            if (response.success) {
                $scope.templates = response.data.templates;
                $scope.templates.forEach(function (v) {
                    if (angular.isDefined(v.image) && v.id === $scope.module.template) {
                        $scope.module.image = v.image;
                    }
                });
            }
        })
        .then(function () {
            $scope.isLoading = false;
        });

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.fileUploaded = false;
        $scope.module.image = "";
    };

    $scope.uploadSuccessBarcode = function (file) {
        $scope.barcode_image = file;
        $scope.barcodeUploaded = true;
        $scope.barcodeError = false;
        $scope.$apply();
    };

    $scope.removeBarcode = function () {
        $scope.barcode_image = undefined;
        $scope.barcodeUploaded = false;
        $scope.module.barcode_image = "";
    };

    $scope.uploadSuccessLogo = function (file) {
        $scope.uploadLogo = file;
        $scope.logoUploaded = true;
        $scope.logoError = false;
        $scope.$apply();
    };

    $scope.removeLogo = function () {
        $scope.uploadLogo = undefined;
        $scope.logoUploaded = false;
        $scope.module.logo = "";
    };

    $scope.uploadSuccessMore = function (file) {
        $scope.uploadMore = file;
        $scope.moreUploaded = true;
        $scope.moreError = false;
        $scope.$apply();
    };

    $scope.removeMore = function () {
        $scope.uploadMore = undefined;
        $scope.moreUploaded = false;
        $scope.module.more = "";
    };

    $scope.isActive = function (value) {
        return (angular.isDefined(value) && value);
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.ok = function () {
        $scope.isLoading = true;
        var module = angular.copy($scope.module);
        module.section_id = $scope.section_id;
        Module.save(module, $scope.editMode, $scope.upload, $scope.barcode_image, $scope.uploadLogo, $scope.uploadMore)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.fileError = false;
                    $modalInstance.close(data.data);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.ERROR.APP_CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };
}]);

sectionsControllers.controller('ModuleElementModalController', ['$scope', '$rootScope', '$state', '$stateParams', '$modalInstance', '$filter', 'growl', 'module', 'module_element', 'Module', 'ModuleElement', 'Upload', function ($scope, $rootScope, $state, $stateParams, $modalInstance, $filter, growl, module, module_element, Module, ModuleElement, Upload) {
    $scope.module = module;
    $scope.module_element = module_element;
    $scope.editMode = angular.isDefined(module_element.id);
    $scope.application_id = $stateParams.application_id;
    $scope.section_id = $stateParams.section_id;
    $scope.order_id = $stateParams.order_id;
    $scope.isLoading = true;
    $scope.fileUploaded = false;
    $scope.fileError = false;
    $scope.fileUploaded_close = false;
    $scope.fileError_close = false;
    $scope.uploadedIconLeft = false;
    $scope.iconLeftError = false;
    $scope.uploadedIconRight = false;
    $scope.iconRightError = false;

    ModuleElement.getModuleElementTags($scope.application_id)
        .then(function (result) {
                let response = result.data;
            if (response.success) {
                $scope.actions = response.data.actions;
                $scope.modules = response.data.modules;
                $scope.providers = response.data.providers;
                $scope.participants = response.data.participants;
                if ($scope.editMode) {
                    if (angular.isNullOrUndefined($scope.module_element.file) || $scope.module_element.file === "") {
                        $scope.fileUploaded = false;
                    }
                    if (angular.isNullOrUndefined($scope.module_element.close) || $scope.module_element.close === "") {
                        $scope.fileUploaded_close = false;
                    }
                    if (angular.isNullOrUndefined($scope.module_element.icon_left) || $scope.module_element.icon_left === "") {
                        $scope.uploadedIconLeft = false;
                    }
                    if (angular.isNullOrUndefined($scope.module_element.icon_right) || $scope.module_element.icon_right === "") {
                        $scope.uploadedIconRight = false;
                    }
                    if ($scope.module_element.action) {
                        $scope.actions.forEach(function (v) {
                            if (v.id === $scope.module_element.action) {
                                $scope.module_element.action = v;
                            }
                        });
                    }
                    if ($scope.module_element.target_module) {
                        $scope.modules.forEach(function (v) {
                            if (v.id === $scope.module_element.target_module) {
                                $scope.module_element.target_module = v;
                            }
                        });
                    }
                    if ($scope.module_element.providers) {
                        $scope.module_element.providers = angular.fromJson($scope.module_element.providers);
                    }
                    if ($scope.module_element.participants) {
                        $scope.module_element.participants = angular.fromJson($scope.module_element.participants);
                    }
                    if ($scope.module_element.opening_hours_week) {
                        var week = $scope.module_element.opening_hours_week.split('-');
                        $scope.module_element.opening_hours_week = {
                            fromTime: week[0],
                            toTime: week[1],
                            from: new Date(1970, 0, 1, week[0].split(':')[0], week[0].split(':')[1]),
                            to: new Date(1970, 0, 1, week[1].split(':')[0], week[1].split(':')[1])
                        };
                    }
                    if ($scope.module_element.opening_hours_weekend) {
                        var weekend = $scope.module_element.opening_hours_weekend.split('-');
                        $scope.module_element.opening_hours_weekend = {
                            fromTime: weekend[0],
                            toTime: weekend[1],
                            from: new Date(1970, 0, 1, weekend[0].split(':')[0], weekend[0].split(':')[1]),
                            to: new Date(1970, 0, 1, weekend[1].split(':')[0], weekend[1].split(':')[1])
                        };
                    }
                }
            }
        })
        .then(function () {
            $scope.isLoading = false;
        });

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.fileUploaded = false;
        $scope.module_element.file = "";
    };

    $scope.uploadSuccessIconLeft = function (file) {
        $scope.uploadIconLeft = file;
        $scope.uploadedIconLeft = true;
        $scope.iconLeftError = false;
        $scope.$apply();
    };

    $scope.removeIconLeft = function () {
        $scope.uploadIconLeft = undefined;
        $scope.uploadedIconLeft = false;
        $scope.module_element.icon_left = "";
    };

    $scope.uploadSuccessIconRight = function (file) {
        $scope.uploadIconRight = file;
        $scope.uploadedIconRight = true;
        $scope.iconRightError = false;
        $scope.$apply();
    };

    $scope.removeIconRight = function () {
        $scope.uploadIconRight = undefined;
        $scope.uploadedIconRight = false;
        $scope.module_element.icon_right = "";
    };

    $scope.uploadSuccess_close = function (file) {
        $scope.upload_close = file;
        $scope.fileUploaded_close = true;
        $scope.fileError_close = false;
        $scope.$apply();
    };
    $scope.removeFile_close = function () {
        $scope.upload_close = undefined;
        $scope.fileUploaded_close = false;
        $scope.module_element.close = "";
    };

    $scope.remove = function () {
        $state.go('appsoup.application.sectionModule', {
            application_id: $scope.application_id,
            section_id: $scope.section_id,
            order_id: $scope.order_id
        });
    };

    $scope.deleteModuleElement = function () {
        $scope.isLoading = true;
        ModuleElement.remove($scope.module_element.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_ELEMENT_DELETED');
                    $state.go('appsoup.application.sectionModule', {
                        application_id: $scope.application_id,
                        section_id: $scope.section_id,
                        order_id: $scope.order_id
                    }, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.ok = function () {

        $scope.isLoading = true;
        var module_element = angular.copy($scope.module_element);
        if (typeof module_element.action === 'object' && module_element.action !== null) {
            module_element.action = module_element.action.id;
        } else {
            module_element.action = 0;
        }
        if (typeof module_element.target_module === 'object' && module_element.target_module !== null) {
            module_element.target_module = module_element.target_module.id;
        } else {
            module_element.target_module = 0;
        }
        if ((typeof module_element.opening_hours_week) !== 'string') {

            if (module_element.opening_hours_week) {

                if (module_element.opening_hours_week.from) {
                    module_element.opening_hours_week.fromTime = $filter('date')(module_element.opening_hours_week.from, 'HH:mm');
                }
                if (module_element.opening_hours_week.to) {
                    module_element.opening_hours_week.toTime = $filter('date')(module_element.opening_hours_week.to, 'HH:mm');
                }
                module_element.opening_hours_week = module_element.opening_hours_week.fromTime + '-' + module_element.opening_hours_week.toTime;
            }
            if (module_element.opening_hours_weekend) {
                if (module_element.opening_hours_weekend.from) {
                    module_element.opening_hours_weekend.fromTime = $filter('date')(module_element.opening_hours_weekend.from, 'HH:mm');
                }
                if (module_element.opening_hours_weekend.to) {
                    module_element.opening_hours_weekend.toTime = $filter('date')(module_element.opening_hours_weekend.to, 'HH:mm');
                }
                module_element.opening_hours_weekend = module_element.opening_hours_weekend.fromTime + '-' + module_element.opening_hours_weekend.toTime;
            }
        }

        module_element.module_id = parseInt($scope.module.id);
        module_element.external = parseInt($scope.module_element.external);
        module_element.add_external = parseInt($scope.module_element.add_external);
        module_element.remove_external = parseInt($scope.module_element.remove_external);
        module_element.availability_external = parseInt($scope.module_element.availability_external);
        module_element.nearest_external = parseInt($scope.module_element.nearest_external);
        module_element.providers = angular.toJson(module_element.providers);
        module_element.participants = angular.toJson(module_element.participants);

        ModuleElement.save(module_element, $scope.editMode, $scope.upload, $scope.upload_close, $scope.uploadIconLeft, $scope.uploadIconRight)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.fileError = false;
                    $modalInstance.dismiss('cancel');
                    $state.go('appsoup.application.sectionModule', {
                        application_id: $scope.application_id,
                        section_id: $scope.section_id,
                        order_id: $scope.order_id
                    }, {reload: true});
                    growl.success('MODULES.ELEMENT.SUCCESS.ELEMENT_EDITED');
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.ERROR.APP_CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

}]);

export default sectionsControllers;
